function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 47.309,
  width: 74.4267,
  height: 6.34074,
  rx: 3.17037,
  transform: "rotate(-39.4679 0 47.309)"
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 1.00049,
  y: 45,
  width: 62.9848,
  height: 5.79483,
  rx: 2.89742
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21 15.0049C36.5035 25.418 42.6909 42.2144 35 60.0049",
  strokeWidth: 7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgIconDeclineScale = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDeclineScale, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-decline-scale.3b3e841f.svg";
export { ForwardRef as ReactComponent };